'use client'

// React Imports
import {useEffect, useState} from 'react'

// Next Imports
import Link from 'next/link'

// MUI Imports
import IconButton from '@mui/material/IconButton'
import {useParams} from "next/navigation";
import {getLocalizedUrl} from "@/utils/i18n";
import {useSession} from "next-auth/react";
import type {Locale} from "@configs/i18n";
import Tooltip from "@mui/material/Tooltip";


const DisclaimerUpload = () => {
    const session = useSession({required: true})
    const [user, setUser]: any = useState(null)

    const {lang: locale}: any = useParams()

    useEffect(() => {
        if (session.status === 'authenticated') {
            const mySession: any = session.data

            setUser(mySession.user)
        }
    }, [session.status]);

    return user?.role <= 30 && (
        <>
            <Tooltip title={locale === 'it' ? 'Impostazioni' : 'Settings'}>
                <IconButton component={Link} href={getLocalizedUrl('/PannelloImpostazioni', locale as Locale)} className='text-textPrimary'>
                    <i className='tabler-settings'/>
                </IconButton>
            </Tooltip>
        </>
    )
}

export default DisclaimerUpload
